import { MapWrapper } from '@vlabs/shared/components/filters-panel/geolocation/map-wrapper/MapWrapper';

import st from '../../popovers.module.sass';

export function MapTab(): JSX.Element {
  return (
    <div className={st.MapTabWrapper}>
      <MapWrapper isFullScreenEnabled />
    </div>
  );
}
